import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import uniq from "lodash/uniq";
import { connect } from "react-redux";
import { Button, Tag, Modal, Table, Icon, message } from "antd";
import { withNamespaces } from "react-i18next";

import classes from "./WizardConfig.css";

import {
  getPermutedBlocksActiveCSVArrayBufferRequest,
  getPermutedBlocksActiveCSVRequest
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";

const colors = [
  "blue",
  "green",
  "purple",
  "cyan",
  "lime",
  "geekblue",
  "gold",
  "volcano",
];
const colorsCohort = ["#317f82", "#2db7f5", "#87d068", "#108ee9", "#cd32bc"];

class PermutedBlocksJson extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      permutedBlocksActive: {},
      isShow: false,
    };
  }

  componentDidMount() {}

  // setData = async () => {
  //   this.setState({ isLoading: true });
  //   const { data } = await getPermutedBlocksActiveJSONRequest();
  //   this.setState({
  //     permutedBlocksActive: data,
  //   });
  //
  //   this.setState({ isLoading: false });
  // };

  downloadCSV = async () => {
    try {
      this.setState(() => ({
        loadingDownloadExample: true,
      }));

      let data = null;

      const response = await getPermutedBlocksActiveCSVArrayBufferRequest();
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `permuted-blocks.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingDownloadExample: false,
    }));
  };

  render() {
    const {
      isShow,
      isLoading,
      loadingDownloadExample,
      permutedBlocksActive,
    } = this.state;

    return (
      <div>
        <Button
          type="primary"
          size="small"
          loading={loadingDownloadExample}
          onClick={this.downloadCSV}
        >
          Download .csv
        </Button>
        <Modal
          visible={isShow}
          onCancel={() => {
            this.setState({ isShow: false });
          }}
          footer={null}
          width={767}
        >
          <h3 className="headline-default">Permuted blocks config</h3>

          {isLoading && <Icon type="loading" />}

          {!isLoading && permutedBlocksActive && (
            <div className={classes.result}>
              <div className={classes.resultItem}>
                <b>State</b>: {get(permutedBlocksActive, "state")}
              </div>
              <div className={classes.resultItem}>
                <b>Approved</b>: {get(permutedBlocksActive, "approved")}
              </div>
              <div className={classes.resultItem}>
                <b>Treatment groups</b>:{" "}
                {JSON.stringify(get(permutedBlocksActive, "treatment_groups"))}
              </div>
              <div className={classes.resultItem}>
                <b>Stratification factors</b>:{" "}
                {JSON.stringify(
                  get(permutedBlocksActive, "stratification_factors")
                )}
              </div>
              <div className={classes.resultItem}>
                <b>Seed</b>: {JSON.stringify(get(permutedBlocksActive, "seed"))}
              </div>
              <div className={classes.resultItem}>
                <b>Approved by signature</b>:{" "}
                {get(permutedBlocksActive, "approved_by_signature")}
              </div>
              <div className={classes.resultItem}>
                <b>Approved by user</b>:{" "}
                {get(permutedBlocksActive, "approved_by_user")}
              </div>
              <div className={classes.resultItem}>
                <b>Approved dt</b>: {get(permutedBlocksActive, "approved_dt")}
              </div>
              <div className={classes.resultItem}>
                <b>Generation source</b>:{" "}
                {get(permutedBlocksActive, "generation_source")}
              </div>
              <div className={classes.resultItem}>
                <b>Number of blocks</b>:{" "}
                {get(permutedBlocksActive, "number_of_blocks")}
              </div>
              <div className={classes.resultItem}>
                <b>Number of elements</b>:{" "}
                {get(permutedBlocksActive, "number_of_elements")}
              </div>
              <div className={classes.resultItem}>
                <b>Strata allocation method</b>:{" "}
                {get(permutedBlocksActive, "strata_allocation_method")}
              </div>
              <div className={classes.resultItem}>
                <b>Block sizes</b>:{" "}
                {JSON.stringify(get(permutedBlocksActive, "block_sizes"))}
              </div>

              <br />
              <h5 className="headline-default">CSV</h5>
              {map(
                get(permutedBlocksActive, "permutation_elements", []),
                (item, i) => {
                  return (
                    <code key={i} className={classes.codeText}>
                      {JSON.stringify(item)}
                    </code>
                  );
                }
              )}
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(PermutedBlocksJson));



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/PermutedBlocksJson.js